/**
 * Client-side mirror of the customer-logo upload contract, so the UI can reject a bad file
 * before spending a round trip. The server re-validates everything and remains the authority —
 * these limits exist for fast feedback, not for safety.
 */

/** Server cap is 2 MiB (configurable per environment); it answers 413 above this. */
export const LOGO_MAX_SIZE_BYTES = 2 * 1024 * 1024;
export const LOGO_MAX_SIZE_LABEL = '2 MB';

export const LOGO_ACCEPTED_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.svg'];

/**
 * `image/jpg` and `image/pjpeg` are accepted because older browsers still report them for JPEG.
 * The server derives the stored content_type from the file's own bytes, never from this header.
 */
export const LOGO_ACCEPTED_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/pjpeg', 'image/svg+xml'];

/** `accept` attribute for the file input — extensions plus MIME types widens OS picker support. */
export const LOGO_FILE_ACCEPT = [...LOGO_ACCEPTED_EXTENSIONS, ...LOGO_ACCEPTED_MIME_TYPES].join(',');

/** Server-side rule: 1-64 chars, first alphanumeric, no slashes or control characters. */
export const LOGO_NAME_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 _.\-&()]{0,63}$/;
export const LOGO_NAME_MAX_LENGTH = 64;
export const LOGO_NAME_RULE_MESSAGE =
    'Use 1-64 characters — letters, digits, space, or _ . - & ( ) — starting with a letter or digit.';

/**
 * `file_url` is presigned and expires 15 minutes after it is minted, so treat it as stale well
 * inside that window. `image_name` is the only stable identifier and is what gets cached.
 */
export const LOGO_URL_STALE_TIME_MS = 10 * 60 * 1000;

export const CUSTOMER_LOGO_QUERY_KEYS = {
    /** The single logo the app shell renders. */
    current: ['customerLogo', 'current'],
    /** The full catalogue shown on the admin page. */
    catalogue: ['customerLogo', 'catalogue'],
};
